import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';
import { reducer as formReducer } from 'redux-form';
import auth from './auth';
import sites from './sites';
import areas from './areas';
import zones from './zones';
import locations from './locations';
import categories from './categories';
import groups from './groups';
import tags from './tags';
import isLoading from './loading';
import users from './users';
import status from './status';
import workflows from './workflows';
import triggers from './triggers';
import actions from './trigger-actions';
import errorBanner from './error-banner';
import notifications from './notifications';
import organizations from './organizations';
import initd from './initd';
import userId from './userId';

const rootReducer = combineReducers({
  form: formReducer,
  i18n: i18nReducer,
  auth,
  sites,
  areas,
  status,
  zones,
  locations,
  categories,
  groups,
  tags,
  isLoading,
  users,
  workflows,
  triggers,
  actions,
  errorBanner,
  notifications,
  organizations,
  initd,
  userId
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js